<template>
  <div class="pamodzi-grey-backgropund">
    <div class=" container">
      <div class="horizontal-timeline pamodzi-grey-backgropund" id="timeline">
        <div class="events-content">
          <div class="pb-5">
            <i id="leftNav" class="bi bi-arrow-left-circle"></i>
            <i id="rightNav" class="bi bi-arrow-right-circle pl-3"></i>
          </div>
          <ul class="">
            <li class="selected text-left p-0 m-0"
                data-horizontal-timeline='{"date": "16/01/1400", "customDisplay": "The Beginning"}'>
              <p class="pamodzi-grey-backgropund p-0">Ntsele, Sithole and Manyoni initially named their company
                Inter-Marketing Enterprises only to land on a
                more appropriate name on a visit to Zambia: ‘Pamodzi’, a Kiswahili word meaning “togetherness”. The new
                name encapsulates their vision for the company: the development and growth of the collective. Pamodzi
                Property Construction (PPC) is born, funded by the trio’s personal endowment policies.</p>
            </li>

            <li class="text-left"
                data-horizontal-timeline='{"date": "16/01/1600", "customDisplay": "A Strong foundation"}'>
              <p class="pamodzi-grey-backgropund p-0">A massive housing shortage in Soweto presented an opportunity to
                the
                company to build what was then
                called “two room and a garage” in the townships. No new houses were being built by the government for
                township residents, creating demand for supplementary living spaces and home extensions. Pamodzi soon
                begins to construct and sell three bedroom houses in Soweto, on land bought from the Urban Foundation.
              </p>
              <p class="pamodzi-grey-backgropund p-0">
                The company also locates a building society which can grant residential loans to potential clients. In
                partnership with a well-known construction company, Pamodzi ventures into petrol stations and helps to
                develop Soweto, Tshwane and sections of Ekurhuleni. School construction is another focus area for
                Pamodzi.
                The group receives a recognition award for the construction of Seana Marena Secondary School in
                Soweto.</p>
            </li>
            <li class="text-left p-0 m-0"
                data-horizontal-timeline='{"date": "16/01/1800", "customDisplay": "Reaching higher"}'>
              <p class="pamodzi-grey-backgropund p-0">A dawning democracy in the early 1990s presents new opportunities
                for
                South African businesses,
                particularly black entrepreneurs. Ntsele and Sithole take the opportunity to approach Nike International
                in 1993 with a plan to launch the global sportswear brand in southern Africa. Within three years, Nike
                South Africa secures its brand dominance on the continent. In 1995, Nike South Africa sponsors the
                victorious Springbok national team during that year’s Rugby World Cup, in a move which marked the
                country’s return to international sport. The Nike Care Trust, which develops sporting facilities in
                underprivileged communities, also builds Sebokeng’s iconic Chris Hani Sports Complex.
                In 1996, Ntsele
                and
                Sithole, together with a group of professionals set up Pamodzi Investment Holdings (PIH), which later
                becomes a serious player in the South African economy. A string of acquisitions soon follows: 20% of
                private hospital group Auckland Investments, South Africa’s largest fleet management solutions company,
                WesBank First Auto (25.1%), leading BMW dealership Auto Bavaria Motors (49%), JSE-listed IT company
                Digicore (25.1%), and 45% of Sodexho Southern Africa (Pty) Ltd. Additional investments include
                short-term
                insurance company Prestasi Brokers, now known as Indwe Risk following a merger with Thebe a leading
                sports
                marketing, sponsorship, hospitality and rights-acquisition business. Pamodzi Sports Marketing and
                Pamodzi
                Leisure Solutions which owns the five-star Tinga Game Park near the Kruger National Park. In 1998
                Pamodzi
                purchases 51% of food manufacturing, marketing and distribution company FoodCorp for R1.9 billion,
                giving
                it control of leading brands such as Yum Yum peanut butter, Ouma Rusks, Nola mayonnaise and Glenryck
                canned pilchards. This becomes the largest management buyout in South Africa.</p>
            </li>
            <li class="text-left p-0 m-0"
                data-horizontal-timeline='{"date": "16/01/2000", "customDisplay": "Leading the market"}'>
              <p class="pamodzi-grey-backgropund p-0">In 2003, the company acquires 30% of world-class stockist,
                distributor
                and processor of stainless steel
                Kulungile Metals (Pty) Ltd, formerly known as Stalcor. The following year, FoodCorp raises the first
                high-yield Eurobond by a South African company – and the largest secondary buyout at the time. Pamodzi
                also buys 28% in Namitech Holdings that same year. In 2007, Pamodzi launches Africa’s biggest private
                equity initiative, the Pamodzi Resources Fund with US$1.3 billion from US investors. That same year,
                subsidiary Pamodzi Coal purchases a 26% stake in Anglo Coal, through the broad-based black economic
                empowerment consortium Inyosi. The resulting R7.4 billion company, Anglo Inyosi Coal, is a fully
                empowered
                South African company with a resource base of over four billion tons of coal. Today, Pamodzi is staying
                true to its history, and continuing to actively seek out new opportunities while introducing a new
                philosophy for business innovation. </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import carousel from 'vue-owl-carousel'

export default {
  name: "AboutRootsDesktop",
  mounted() {
    // eslint-disable-next-line no-undef
    $('#timeline').horizontalTimeline({
      desktopDateIntervals: 500,
      tabletDateIntervals: 500,
      mobileDateIntervals: 500,
      minimalFirstDateInterval: true,

      smoothScroll: true,
      // iconClass: {
      //   "base": "fas fa-3x", // Space separated class names
      //   "scrollLeft": "fa-chevron-circle-left",
      //   "scrollRight": "fa-chevron-circle-right",
      //   // "prev": "fa-arrow-circle-left",
      //   // "next": "fa-arrow-circle-right",
      //   // "pause": "fa-pause-circle",
      //   // "play": "fa-play-circle"
      // },
      animationClass: {
        "base": "animationSpeed", // Space separated class names
        "enter": {
          "left": "enter-left",
          "right": "enter-right"
        },
        "exit": {
          "left": "exit-left",
          "right": "exit-right"
        }
      }
      /* End new object options */
    });
  }
}
</script>

<style scoped>
.bi:hover {
  color: #9B1D00;
}

.horizontal-timeline .events-content li {
  background-color: #d0d0d0;
}

.timeline-navigation a {
  visibility: hidden !important;
}


.horizontal-timeline .filling-line {
  background-color: #000000 !important;
}

.timeline-navigation {
  visibility: hidden !important;
}

ul {
  list-style-type: none !important;
  margin-left: 0px;
  padding-left: 0px;
}


</style>
